import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import axios from "../../../context/axios";
import { initTE, Ripple } from "tw-elements";

const ServiceCategories = () => {
  const [categories, setCategories] = useState([]);
  const [topCategories, setTopCategories] = useState([]);
  const [mainCategory, setMainCategory] = useState(null);

  useEffect(() => {
    initTE({ Ripple });

    const fetchData = async () => {
      try {
        const catRes = await axios.get("/categories");

        const allCats = catRes.data;

        // const main = allCats[0];

        // const rest = allCats.slice(1).slice(0, 6);
        const main = allCats.reduce((prev, current) =>
          (prev.totalPackages || 0) > (current.totalPackages || 0)
            ? prev
            : current
        );

        // Filter out main from rest and take top 6
        // const rest = allCats.filter((cat) => cat._id !== main._id).slice(0, 6);
        const rest = allCats
  .filter(cat => cat._id !== main._id)
  .sort((a, b) => (b.totalPackages || 0) - (a.totalPackages || 0))
  .slice(0, 6);
        setTopCategories(rest);
        setMainCategory(main); // Store it separately
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };
    window.scrollTo(0, 0);
    fetchData();
  }, []);
  return (
    <div className="bg-white">
      <div className="mt-6 flex flex-col lg:flex-row gap-6">
        {/* Left side - Big single category */}
        {mainCategory && (
          <div className="lg:w-2/5">
            {/* <Link
  to="/packagelist"
  state={{
    payload: { categoryId: mainCategory._id },  // Use `_id` not `id`
  }}
  onClick={() => console.log("Clicked category:", mainCategory._id)}
> */}
            <Link
              to={`/packagelist?category=${mainCategory._id}`}
              onClick={() => console.log("Clicked category:", mainCategory._id)}
            >
              {" "}
              <div className="group relative h-full rounded-3xl overflow-hidden shadow-lg transition-all duration-300 hover:shadow-xl">
                <div
                  className="relative h-full min-h-[640px] w-full"
                  style={{
                    backgroundImage: `url(${
                      mainCategory.photo || mainCategory.image
                    })`,
                    backgroundSize: "cover",
                    backgroundPosition: "center center",
                    backgroundRepeat: "no-repeat",
                    imageRendering: "auto",
                    backgroundColor: "#f3f4f6",
                  }}
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/50 to-transparent flex flex-col justify-end p-6 space-y-2">
                    <h3 className="text-3xl font-bold text-white drop-shadow-lg leading-tight">
                      {mainCategory.title || mainCategory.name}
                    </h3>
                    <div className="flex items-center space-x-2">
                      <span className="text-xl font-semibold text-white/90 drop-shadow-md">
                        {mainCategory.totalPackages || 0}+
                      </span>
                      <span className="text-base font-medium text-white/80 drop-shadow-sm">
                        Packages
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        )}

        {/* Right side - Top 6 fetched categories */}
        <div className="lg:w-3/5 flex flex-col gap-4">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 h-1/2">
            {topCategories.slice(0, 3).map((cat) => (
              // <Link
              //   to={{
              //     pathname: `/${cat.slug}`,
              //     state: { categoryId: cat.id }, // pass categoryId in location state
              //   }}
              //   key={cat.id}
              // >
              <Link
                to={`/packagelist?category=${cat._id}`}
                onClick={() => console.log("Clicked category:", cat._id)}
              >
                {" "}
                <div className="group relative h-full rounded-xl overflow-hidden shadow-lg transition-all duration-300 hover:shadow-xl">
                  <div
                    className="relative h-full min-h-[300px] w-full"
                    style={{
                      backgroundImage: `url(${cat.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center center",
                      backgroundRepeat: "no-repeat",
                      imageRendering: "auto",
                      backgroundColor: "#f3f4f6",
                    }}
                  >
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/50 to-transparent flex flex-col justify-end p-6 space-y-2">
                      <h3 className="text-1xl font-bold text-white drop-shadow-lg leading-tight">
                        {cat.name}
                      </h3>
                      <div className="flex items-center space-x-2">
                        <span className="text-xl font-semibold text-white/90 drop-shadow-md">
                          {cat.totalPackages || 0}+
                        </span>
                        <span className="text-base font-medium text-white/80 drop-shadow-sm">
                          Packages
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 h-1/2">
            {topCategories.slice(3, 6).map((cat) => (
              <Link
                to={{
                  pathname: `/${cat.slug}`,
                  state: { categoryId: cat.id }, // pass categoryId in location state
                }}
                key={cat.id}
              >
                {" "}
                <div className="group relative h-full rounded-xl overflow-hidden shadow-lg transition-all duration-300 hover:shadow-xl">
                  <div
                    className="relative h-full min-h-[300px] w-full"
                    style={{
                      backgroundImage: `url(${cat.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center center",
                      backgroundRepeat: "no-repeat",
                      imageRendering: "auto",
                      backgroundColor: "#f3f4f6",
                    }}
                  >
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/50 to-transparent flex flex-col justify-end p-6 space-y-2">
                      <h3 className="text-1xl font-bold text-white drop-shadow-lg leading-tight">
                        {cat.name}
                      </h3>
                      <div className="flex items-center space-x-2">
                        <span className="text-xl font-semibold text-white/90 drop-shadow-md">
                          {cat.totalPackages || 0}+
                        </span>
                        <span className="text-base font-medium text-white/80 drop-shadow-sm">
                          Packages
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCategories;
